














import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Icon extends Vue {
  @Prop({ required: true })
  public readonly icon!: string;

  @Prop({ default: '' })
  private readonly colour!: string;

  @Prop({ default: 'md' })
  private readonly pack!: string;

  @Prop({ default: '1em' })
  public readonly width!: string;

  @Prop({ default: '1em' })
  public readonly height!: string;

  @Prop({ default: true })
  public readonly justifyContent!: string;

  @Prop({ default: '0em' })
  public readonly margin!: string;

  @Prop()
  public readonly block!: boolean;

  get fileName(): string {
    const parts = [this.pack];

    if (this.colour) parts.push(this.colour);

    parts.push(`${this.icon}.svg`);

    return parts.join('/');
  }
}
